import React from 'react'

import Form from './Form/AccordionForm'
import { defaultSettings } from './defaults/settings'
import { Accordion } from '@peracto/peracto-blocks-tailwind'

const createPlugin = settings => {
    const mergedSettings = { ...defaultSettings, ...settings }

    const RenderComponent = Accordion

    return {
        FormComponent: props => <Form {...props} />,
        Component: props => <RenderComponent.Component {...props} {...mergedSettings} />,

        name: 'peracto/content/accordion',
        version: '1.0.0',
        text: mergedSettings.translations.pluginName,
        description: mergedSettings.translations.pluginDescription,
        IconComponent: mergedSettings.IconComponent,

        createInitialState: () => ({
            label: mergedSettings.defaultLabel,
            accordion: [],
            selectedAccordionIndex: 0,
            headerColour: '#000000',
            headerFontSize: 3,
            headerBackgroundColour: 'transparent',
            headerFont: 'body',
            headerFontWeight: 'normal',
        }),
    }
}

export default createPlugin
